<template>
  <div>
    <v-app-bar
      class="header-mobile"
      scroll-threshold="100"
      elevate-on-scroll
      hide-on-scroll
      color="white"
      app
    >
      <router-link to="/">
        <img
          v-if="informations.img"
          :src="files + informations.img"
          :alt="informations.name"
          height="46px"
          class="d-block"
        />
      </router-link>

      <v-spacer />

      <template v-for="(item, keySocial) in social">
        <v-btn
          v-if="item"
          :key="keySocial"
          :href="item.link"
          target="blank"
          class="mr-1 d-flex"
          width="40px"
          height="40px"
          icon
        >
          <v-icon color="primary" size="20">
            {{ item.icon }}
          </v-icon>
        </v-btn>
      </template>

      <v-app-bar-nav-icon color="primary" @click="showNavigationDrawer" />
    </v-app-bar>
  </div>
</template>

<script>
import { getSocial } from "../../../utils/getSocial";

export default {
  data() {
    return {
      current: this.$route.path,
      drawer: false,
    };
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return getSocial(this.informations);
    },
  },
  methods: {
    showNavigationDrawer() {
      window.showNavigationDrawer();
    },
  },
};
</script>
